module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/05649236fbbcee12a260894921755795.gif";